/**
 * Waits for a specified condition to be true before resolving a Promise.
 *
 * @param {() => boolean} condition - A function that returns a boolean indicating if the condition is met.
 * @param {number} [timeout] - The maximum time to wait in milliseconds.
 * @param {number} [interval] - The interval at which to check the condition in milliseconds.
 * @returns {Promise<void>} A Promise that resolves when the condition is true or rejects if the timeout is reached.
 */
export async function waitFor(
  condition: () => boolean,
  timeout = 5000,
  interval = 100,
) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now()

    function checkCondition() {
      if (condition()) {
        resolve(true)
      }
      else if (Date.now() - startTime >= timeout) {
        reject(new Error('Timeout waiting for condition'))
      }
      else {
        setTimeout(checkCondition, interval)
      }
    }

    checkCondition()
  })
}
